import { InsuranceCompany } from 'types'
import z from 'zod'

export const analysisFiltersSchema = z.object({
  insuranceCompanies: z.array(z.enum(InsuranceCompany)).optional(),
  groupUuids: z.array(z.string()).optional(),
  policyUuids: z.array(z.uuid()).optional(),
  insuredCompanyCountryCodes: z.array(z.string()).optional(),
  debtorCompanyCountryCodes: z.array(z.string()).optional(),
  dateRange: z.object({ from: z.number(), to: z.number() }).optional(),
  insuredCompanyUuids: z.uuid().array().optional(),
})

export type AnalysisFilters = z.infer<typeof analysisFiltersSchema>
